import { useMutation, useQueryClient } from "@tanstack/react-query"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { toast } from "sonner"

import { api } from "@/lib/api-client"
import { queryKeys } from "@/lib/query-keys"

import { useAIParserSession } from "./use-ai-parser-session"

type EditTitleData = {
  sessionId: string | null
  title: string
}

function editTitle(data: EditTitleData): Promise<{ session_id: string }> {
  const { sessionId, title } = data

  return api.put("/parser/edit-title", {
    session_id: sessionId,
    title,
  })
}

export function useEditTitleMutation() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const { currentSessionId, setCurrentSessionId, sessionType } = useAIParserSession()

  return useMutation({
    mutationFn: editTitle,
    onSuccess: (data) => {
      setCurrentSessionId(data.session_id)
      void queryClient.invalidateQueries({
        queryKey: queryKeys.fullSession(currentSessionId ?? ""),
      })

      void queryClient.invalidateQueries({
        queryKey: queryKeys.sessionHistory(sessionType),
      })

      toast.success(t("pages.ai_parser.toasts.title_updated"))

      // Navigate to the correct session URL
      void navigate(`/ai-parser/chat/${data.session_id}`)
    },
  })
}
